<ion-card class="auth-card">
  <app-card-header-title-subtitle
    icon="icon-pulgar-arriba"
    [title]="'auth-verification.' + title"
    [subtitle]="'auth-verification.' + subtitle"
    [icon]="icon"
  >
  </app-card-header-title-subtitle>

  <ion-card-content class="p-0">
    @if (process === 'tokenCaducado') {
    <a (click)="_goSendEmail()"
      >{{ 'auth-verification.send-email' | translate }}
    </a>
    }
    <ion-item-divider></ion-item-divider>
    <ion-row class="auth-card__buttons">
      <ion-col size="12" sizeMd="2">
        <ion-button fill="outline" (click)="_btnBack()">
          {{ 'auth-verification.btn-back' | translate }}
        </ion-button>
      </ion-col>
      @if(showContinueBtn) {
      <ion-button
        #button
        (click)="_btnCont()"
        class="ion-float-right button-solid"
        expand="block"
      >
        {{ 'auth-verification.btn-continue' | translate }}
      </ion-button>
      }
    </ion-row>
  </ion-card-content>
</ion-card>
